import React from "react";

export default function Membership(props) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="17.6" height="11.2" viewBox="0 0 17.6 11.2">
			<path
				id="ic_group_24px"
				d="M13,9.8a2.4,2.4,0,1,0-2.4-2.4A2.39,2.39,0,0,0,13,9.8Zm-6.4,0A2.4,2.4,0,1,0,4.2,7.4,2.39,2.39,0,0,0,6.6,9.8Zm0,1.6c-1.864,0-5.6.936-5.6,2.8v2H12.2v-2C12.2,12.336,8.464,11.4,6.6,11.4Zm6.4,0c-.232,0-.5.016-.776.04A3.376,3.376,0,0,1,13.8,14.2v2h4.8v-2C18.6,12.336,14.864,11.4,13,11.4Z"
				transform="translate(-1 -5)"
				fill={props.color || "#2d6fa7"}
			/>
		</svg>
	);
}

export function MembershipLg() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="100" height="64">
			<path
				d="M68.182 27.429a13.619 13.619 0 0 0 13.591-13.715 13.614 13.614 0 1 0-13.591 13.715Zm-36.364 0a13.619 13.619 0 0 0 13.591-13.715 13.614 13.614 0 1 0-13.591 13.715Zm0 9.143C21.227 36.571 0 41.92 0 52.571V64h63.636V52.571c0-10.651-21.227-16-31.818-16Zm36.364 0c-1.318 0-2.818.091-4.409.229 5.273 3.84 8.955 9.006 8.955 15.771V64H100V52.571c0-10.651-21.227-16-31.818-16Z"
				fill={props.color || "#2d6fa7"}
			/>
		</svg>
	);
}
